import styled from 'styled-components';

export const RegisterContainerStyled = styled.div``;
